import { render, staticRenderFns } from "./bShowFloors.vue?vue&type=template&id=01f87c91&scoped=true"
import script from "./bShowFloors.vue?vue&type=script&lang=js"
export * from "./bShowFloors.vue?vue&type=script&lang=js"
import style0 from "./bShowFloors.vue?vue&type=style&index=0&id=01f87c91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f87c91",
  null
  
)

export default component.exports